/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: 890, // min width in pixels
  menu_toggle: '#menu-toggle' // selector for toggle
});

/**
 * Responsive videos
 */
fitvids();

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });

  });
}

/**
* Get nav height
*/
/**
jQuery(document).ready(function(){
      var headerHeight = jQuery('.site-header').outerHeight();
      var heroCont = jQuery('.hero__container-push')
      var heroContHeight = jQuery(heroCont).css('padding-top').replace(/[^-\d\.]/g, '');;
      console.log(headerHeight);
      console.log(heroContHeight);
      var addPaddingTop = Number(headerHeight) + Number(heroContHeight);
      console.log(addPaddingTop);
      jQuery(heroCont).css('padding-top', addPaddingTop);
});
*/

  // Rellax
  var rellax = new Rellax('.rellax');

// Video bg

function isIE () {
    var myNav = navigator.userAgent.toLowerCase();
    return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
}

window.isIEOld = isIE() && isIE() < 9;
window.isiPad = navigator.userAgent.match(/iPad/i);

var img = jQuery('.video').data('placeholder'),
    video = jQuery('.video').data('video'),
    noVideo = jQuery('.video').data('src'),
    el = '';


    el +=   '<video playsinline autoplay loop muted poster="' + img + '">';
    el +=       '<source src="' + video + '" type="video/mp4">';
    el +=   '</video>';


jQuery('.video').prepend(el);

if(jQuery('.vertical-menu > .menu-item').hasClass('current-menu-item') || jQuery('.vertical-menu > .menu-item').hasClass('active')) {
  jQuery('.current-menu-item > .dropdown-menu').addClass('d-block');
}
if(jQuery('.vertical-menu > .menu-item').hasClass('current-menu-parent') || jQuery('.vertical-menu > .menu-item').hasClass('active')) {
  jQuery('.current-menu-parent > .dropdown-menu').addClass('d-block');
}
if ( jQuery( ".gallery" ).length ) {
jQuery(document).ready(function(){
  jQuery('.gallery').slickLightbox({
    itemSelector: '> a'
});
});
};

jQuery("p small").parent().addClass("sub-small");

if (jQuery('#modalDisclaimer')) {
  jQuery('#modalDisclaimer').modal('show');
}
function closeDisclaimer(){
jQuery('#modalDisclaimer').modal('hide');
//pop the window to select items
}
function submitLocation(){
  var result = document.getElementById("country").value;
  if(result === 'United States' || result ===  'Australia' || result === 'Canada' || result === 'Hong Kong' || result === 'Japan' || result === 'South Africa' || result === 'New Zealand' || result === 'Singapore' || result === 'Yhdysvallat' || result === 'Kanada' || result === 'Uusi-Seelanti' || result === 'Japani' || result === 'Etelä-Afrikka')  {

  jQuery('.restricted').addClass('phase-show');
  jQuery('.phase-one').addClass('phase-hide');
  // Your application has indicated there's an error
  lang = document.documentElement.lang;
    window.setTimeout(function(){
    if(lang == 'en-US') {
    window.location.href = "/investors/";
    }
    if(lang == 'fi' || jQuery('#modalContentFI').length) {
    window.location.href = "/fi/sijoittajat/";
    }

    }, 1000);
  }
  if(result === 'Finland and other countries'  || result === 'Suomi ja muut maat' ) {
  jQuery('.non-restricted').addClass('phase-show');
  jQuery('.phase-one').addClass('phase-hide');
  }
}
function doNotAgree() {
  lang = document.documentElement.lang;
  window.setTimeout(function(){

  if(lang == 'en-US') {
  window.location.href = "/investors/";
  }
  if(lang == 'fi' || jQuery('#modalContentFI').length) {
  window.location.href = "/fi/sijoittajat/";
  }
  }, 200);
}

jQuery( "a.general-meeting" ).on('click', function() {
  var w=window.open(this.href,'eGM','width=750,height=700,resizable=yes,scrollbars=yes');
  if(window.focus){w.focus()}
  return false;
});

/* ---------------------------------- styled table ------------------------- */
jQuery(function($) {
  $('table.styled-table tr, .styled-table table tr').each(function(rowIndex, rowElement) {
    const rowTdIndexes = getTdIndexes($(rowElement).find('td'))
      
      $(rowElement).find('td').each(function (loopTdIndex, tdElement) {
        $(tdElement).attr('data-custom_index', rowTdIndexes[loopTdIndex])
      })
  })
  $('table.styled-table tr td, .styled-table table tr td').on('click', handleHighlights)

  function handleHighlights () {
    const parentTable = $(this).parents('table')

    // check if current row is last row when excluded
    if($(this).parents('.styled-table').hasClass('exclude-last-row') && $(parentTable).find('tr:last-child').is($(this).parents('tr'))) {
      return
    }
  
    // remove old highlights
    parentTable.find('td.border-left-highlight').removeClass('border-left-highlight')
    parentTable.find('td.border-right-highlight').removeClass('border-right-highlight')
    parentTable.find('td.borders-highlight').removeClass('borders-highlight')
    parentTable.find('td.first-td-highlight').removeClass('first-td-highlight')
    parentTable.find('td.td-highlight').removeClass('td-highlight')
    
    // selected td custom index
    let currentCustomIndex = stringToArray($(this).data('custom_index'))

    const firstRow = $(parentTable).find('tr:first-child')
    let firstRowCustomIndex = 0

    // get first row td custom index
    $(firstRow).find('td').each(function (tdIndex, tdElement) {
      const customIndex = stringToArray($(tdElement).data('custom_index'))
      if(hasSameCustomIndex(currentCustomIndex, customIndex)) {
        // highlist td on first row
        $(tdElement).addClass('first-td-highlight')
        
        firstRowCustomIndex = customIndex
      }
    })

    if(!$(parentTable).find('tr:first-child').is($(this).parents('tr'))) {
      // highlight td 
      $(this).addClass('td-highlight')
      $(this).siblings('td').addClass('td-highlight')
    }
    let excludeLastRow = ''
    // check if last row should be excluded from highlights
    if($(this).parents('.styled-table').hasClass('exclude-last-row')) {
      excludeLastRow = ':not(:last-child)'
    }

    // highlight column td borders
    $(parentTable).find('tr:not(:first-child)' + excludeLastRow).each(function (loopRowIndex, rowElement) {

      // loop td elements
      $(rowElement).find('td').each(function (loopTdIndex, tdElement) {
        let tdCustomIndex = stringToArray($(tdElement).data('custom_index'))

        // compare td custom index to first row custom index
        const hasCustomIndex = hasSameCustomIndex(firstRowCustomIndex, tdCustomIndex)

        if(typeof(hasCustomIndex) === 'boolean' && hasCustomIndex) {
          //boolean true (same column)
          $(tdElement).addClass('borders-highlight')
        } else if(typeof(hasCustomIndex) === 'number') {
          // number (same column, no colspan)
          if(hasCustomIndex === 0) {
            // first
            $(tdElement).addClass('border-left-highlight')
          } else if(hasCustomIndex === (firstRowCustomIndex.length - 1)) {
            // last
            $(tdElement).addClass('border-right-highlight')
          }
        }
        
        
      })

     
    })
  }

  // get indexes of row td
  function getTdIndexes (tdArray) {
    let index = 0
    let rowTdIndexes = {}
    
    $(tdArray).each(function(tdIndex, element) {
      const tdColspan = parseInt($(element).attr('colspan'))

      // check if has colspan
      if(tdColspan > 1) {
        let indexArray = []
        for (let i = 0; i < tdColspan; i++) {
          indexArray.push(index)
          index++
        }
        rowTdIndexes[tdIndex] = indexArray
      } else {
        rowTdIndexes[tdIndex] = index
        index++
      }
    })
    
    return rowTdIndexes
  }

  // return custom data index as
  function stringToArray(value) {
    if(typeof(value) === 'string') {
      // convert string to array of numebrs
      value = value.split(',').map(function(item) {
        return parseInt(item, 10)
      })
    }
    return value
  }

  // compare custom indexes
  function hasSameCustomIndex (currentCustomIndex, comparedCustomIndex) {
    if(typeof(currentCustomIndex) === 'number' && typeof(comparedCustomIndex) === 'number') {
      // number - number
      if(currentCustomIndex === comparedCustomIndex) {
        return true
      }

    } else if(typeof(currentCustomIndex) === 'number' && Object.prototype.toString.call(comparedCustomIndex) === '[object Array]') {
      // number - array
      if(comparedCustomIndex.indexOf(currentCustomIndex) > -1) {
        return true
      }

    } else if(Object.prototype.toString.call(currentCustomIndex) === '[object Array]' && typeof(comparedCustomIndex) === 'number') {
      // array - number
      const arrayIndex = currentCustomIndex.indexOf(comparedCustomIndex)
      if(arrayIndex > -1) {
        return arrayIndex
      }

    } else {
      // array - array
      if(currentCustomIndex.sort().toString() == comparedCustomIndex.sort().toString()) {
        return true
      }
    }

    return false
  }

  /* fix for scrolling to error message in woocommerce checkout */
  $.scroll_to_notices = function() {
    $('html, body').animate({
      scrollTop: $('#main').offset().top - 100
    }, 1000)
  }
  
  /* ----------------------- embedded video ----------------------------- */

  $('.wistia_embed, .wp-embedded-content').parent().addClass('embedded-video-container')

  /* -------------------- blog form inputs --------------- */

  if($('.blog-form-container').length > 0) {

    let searchParams = new URLSearchParams(window.location.search)
  
    // set view on page load
    if(searchParams.has('view') && searchParams.get('view') !== '') {
      if(searchParams.get('view') === 'news') {
        $('.teaser-container').removeClass('hidden-view')
        $('.events-container').addClass('hidden-view')
      } else {
        $('.teaser-container').addClass('hidden-view')
        $('.events-container').removeClass('hidden-view')
      }
    }
  
    // submit form when changing sorting
    $('.article-sorting-container').on('change', '#articles-sorting', function() {
      $(this).parents('#blog-form').trigger('submit')
    })
  
    $('.articles-display-container').on('change', '#articles-display', function() {
      const selectedView = $(this).val()
  
      if(selectedView === 'news') {
        $('.teaser-container').removeClass('hidden-view')
        $('.events-container').addClass('hidden-view')
      } else {
        $('.teaser-container').addClass('hidden-view')
        $('.events-container').removeClass('hidden-view')
      }
    })
  }

  /* -------------------- study listing --------------- */

  $('.study-list').on('click', '.title-container', function() {
    $(this).toggleClass('open')
    $(this).siblings('.list-container').toggle()
  })
})